import React from 'react';
import * as ROUTES from '../../../router/Routes';
import ContainerTemplate from '../../../widgets/template/Container';
import EstudiantesView from './EstudiantesView';

const EstudiantesModule = () => {
  return (
    <ContainerTemplate
      active={ROUTES.estudiantes}
      routes={[ROUTES.controlEstudios]}
    >
      <EstudiantesView />
    </ContainerTemplate>
  );
};

export default EstudiantesModule;
